import React, { useState, useEffect, useRef, useCallback } from 'react';
import { FiX, FiMaximize2 } from 'react-icons/fi';
import './Gallery.css';

const images = [
  { src: `${process.env.PUBLIC_URL}/lobby.jpeg`, alt: 'Modern customer lobby at Axis Collision Center in Spring TX' },
  { src: `${process.env.PUBLIC_URL}/drive%20in%20inspection%20bay-4.jpeg`, alt: 'Covered drive-in inspection bay for vehicle damage assessment' },
  { src: `${process.env.PUBLIC_URL}/insurance%20drive%20in%20adjuster%20desk.jpeg`, alt: 'Insurance adjuster desk for streamlined claims processing' },
  { src: `${process.env.PUBLIC_URL}/work%20bay-13.jpeg`, alt: 'Professional collision repair work bay with modern equipment' },
  { src: `${process.env.PUBLIC_URL}/auto%20bay-9.jpeg`, alt: 'Full-service auto repair bay' },
  { src: `${process.env.PUBLIC_URL}/tow%20truck-8.jpeg`, alt: 'Axis Collision Center tow truck for accident recovery' },
  { src: `${process.env.PUBLIC_URL}/refinishing%20department-6.jpeg`, alt: 'Paint refinishing department with professional spray booth' },
  { src: `${process.env.PUBLIC_URL}/low%20profile%20wheell%20align-7.jpeg`, alt: 'Wheel alignment equipment for precision repairs' }
];

const Gallery = () => {
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const closeButtonRef = useRef(null);
  const triggerRef = useRef(null);

  const closeLightbox = useCallback(() => {
    setLightboxOpen(false);
    setSelectedImage(null);
    document.body.style.overflow = 'auto';
    if (triggerRef.current) {
      triggerRef.current.focus();
    }
  }, []);

  const openLightbox = (image, e) => {
    triggerRef.current = e.currentTarget;
    setSelectedImage(image);
    setLightboxOpen(true);
    document.body.style.overflow = 'hidden';
  };

  useEffect(() => {
    if (lightboxOpen && closeButtonRef.current) {
      closeButtonRef.current.focus();
    }
  }, [lightboxOpen]);

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === 'Escape' && lightboxOpen) {
        closeLightbox();
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [lightboxOpen, closeLightbox]);

  return (
    <section id="gallery" className="gallery section">
      <div className="container">
        <div className="gallery__header">
          <h2 className="gallery__title">Our Facility</h2>
          <p className="gallery__subtitle">
            State-of-the-art equipment and professional workspace for superior results
          </p>
        </div>
        <div className="gallery__grid" role="list">
          {images.map((image, index) => (
            <div
              key={index}
              className="gallery__item"
              onClick={(e) => openLightbox(image, e)}
              onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); openLightbox(image, e); }}}
              role="listitem"
              tabIndex={0}
              aria-label={`View ${image.alt}`}
            >
              <img src={image.src} alt={image.alt} loading="lazy" width="400" height="300" />
              <div className="gallery__item-overlay" aria-hidden="true">
                <FiMaximize2 />
              </div>
            </div>
          ))}
        </div>
      </div>

      {lightboxOpen && (
        <div
          className="lightbox"
          onClick={closeLightbox}
          role="dialog"
          aria-modal="true"
          aria-label={`Viewing: ${selectedImage?.alt}`}
        >
          <button
            className="lightbox__close"
            onClick={closeLightbox}
            ref={closeButtonRef}
            aria-label="Close lightbox"
          >
            <FiX />
          </button>
          <div className="lightbox__content" onClick={(e) => e.stopPropagation()}>
            <img src={selectedImage.src} alt={selectedImage.alt} />
          </div>
        </div>
      )}
    </section>
  );
};

export default Gallery;
